import React from "react";
import "./styles/ContentActivityFooter.scss";
import SimpleButton from "../../../../components/SimpleButton/SimpleButton";
import NewActivityIcon from "../../../../components/VectorIcons/NewActivityIcon";
import { Box, Button } from "@mui/material";

const ContentActivityFooter = ({
  isValid,
  onCreateActivity,
  onCancel,
  floating,
  selectedCount = 0,
}) => {
  const noAttachmentsSelectedMessage = `Selecione o(s) anexo(s) para adicionar à atividade`;
  const formattedCount = String(selectedCount).padStart(2, "0");
  const selectedAttachmentsMessage =
    selectedCount === 1
      ? `${formattedCount} anexo selecionado`
      : `${formattedCount} anexos selecionados`;

  return (
    <div className={`contentActivityFooter${floating ? " floating" : ""}`}>
      <span>
        {selectedCount > 0
          ? selectedAttachmentsMessage
          : noAttachmentsSelectedMessage}
      </span>

      <Box sx={{ display: "flex", gap: "24px" }}>
        {selectedCount > 0 && (
          <Button
            variant="outlined"
            onClick={onCancel}
            sx={{
              color: "#fff",
              borderColor: "#fff",
              fontFamily: "Globotipo Text",
              textTransform: "none",
              fontWeight: "bold",
              px: "24px",
              fontSize: "16px",
              "&:hover": {
                borderColor: "#fff",
                backgroundColor: "rgba(255,255,255,0.08)",
              },
            }}
          >
            Cancelar
          </Button>
        )}

        <SimpleButton
          text="Criar atividade"
          classButton="buttonBlue"
          onBreadcrumb={true}
          isValidForm={isValid}
          toValidate={true}
          clickEvent={onCreateActivity}
        >
          <NewActivityIcon />
        </SimpleButton>
      </Box>
    </div>
  );
};

export default React.memo(ContentActivityFooter);
